module.exports = __webpack_public_path__ + "img/game_night_graphic.76ae0eca.png";